import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { UserProfile } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';

const TABS = [
    { id: 'account', label: 'Profile' },
    { id: 'security', label: 'Security' },
];

function tabFromHash() {
    const hash = window.location.hash.replace(/^#\/?/, '');
    if (hash.startsWith('security')) return 'security';
    return 'account';
}

function clearHash() {
    const url = window.location.pathname + window.location.search;
    window.history.replaceState(null, '', url);
}

const MyAccount = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState(tabFromHash);

    useEffect(() => {
        const onHashChange = () => setActiveTab(tabFromHash());
        window.addEventListener('hashchange', onHashChange);
        return () => window.removeEventListener('hashchange', onHashChange);
    }, []);

    const selectTab = (tab) => {
        if (tab.id === 'account') {
            // Clerk's account/profile view is the default route (no hash).
            // #/account does not resolve — clear hash and remount via key.
            clearHash();
        } else {
            window.location.hash = '#/security';
        }
        setActiveTab(tab.id);
    };

    return (
        <>
            <Helmet>
                <title>Account Settings | TLK</title>
            </Helmet>
            <div className="main-body">
                <div className="main-header-s1 center-text">
                    <button
                        type="button"
                        className="back-btn"
                        onClick={() => navigate('/user/dashboard')}
                    >
                        <img src="/images/icons/chevron-left.svg" alt="" />
                    </button>
                    <h1 className="main-header-s1__title">Account Settings</h1>
                    {/* <button type="button" className="transparent-btn">
                        <img src="/images/icons/info.svg" alt="" />
                    </button> */}
                    <div className="main-header-s1__right"></div>
                </div>
                <div className="body-content">
                    <div className="creator-user-profile">
                        <div className="creator-user-profile__tabs" role="tablist">
                            {TABS.map((tab) => (
                                <button
                                    key={tab.id}
                                    type="button"
                                    role="tab"
                                    aria-selected={activeTab === tab.id}
                                    className={
                                        activeTab === tab.id
                                            ? 'creator-user-profile__tab is-active'
                                            : 'creator-user-profile__tab'
                                    }
                                    onClick={() => selectTab(tab)}
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </div>
                        {/* Remount when tab changes so Clerk picks up cleared vs #/security hash */}
                        <UserProfile
                            key={activeTab}
                            routing="hash"
                            appearance={{
                                elements: {
                                    rootBox: 'w-full',
                                    cardBox: 'w-full shadow-none',
                                    navbar: { display: 'none' },
                                    navbarMobileMenuRow: { display: 'none' },
                                },
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

export default MyAccount;
